import React, { useEffect, useState } from "react";
import { Text } from "@amzn/meridian";
import CameraFrame from "../../inspection/cameraFrame";
import StepTransitionSheet from "./StepTransitionSheet";
import ContainerCountOverlay from "./ContainerCountOverlay";
import { CameraStreamProps } from "../types/cameraStreamProps";
import "./detectObjectStep.scss";

interface DetectObjectStepProps {
  humanText: string;
  target: string[];
  activeQuestionIds: string[];
  onComplete: () => void;
  cameraStreamProps: CameraStreamProps;
}

const DetectObjectStep: React.FC<DetectObjectStepProps> = ({
  humanText,
  target,
  activeQuestionIds,
  onComplete,
  cameraStreamProps,
}) => {
  const [stepComplete, setStepComplete] = useState(false);
  const stepKey = `${humanText}-${target.join(",")}-${activeQuestionIds.join(",")}`;

  useEffect(() => {
    setStepComplete(false);
  }, [stepKey]);

  return (
    <div className="detect-object-step pwa-fullscreen-viewport">
      <div className="human-text-overlay">
        <Text color="inverted" alignment="center" className="human-text-overlay__text">{humanText}</Text>
      </div>
      <ContainerCountOverlay />
      <CameraFrame
        onCapture={() => setStepComplete(true)}
        targetClasses={target}
        activeQuestionIds={activeQuestionIds}
        cameraStreamProps={cameraStreamProps}
      />
      { stepComplete && <StepTransitionSheet
        headerMessage="Photo Uploaded!"
        message="AI analysis running in background. Moving to next step."
        onClose={onComplete}
      />}
    </div>
  );
};

export default DetectObjectStep;
